import * as React from "react"
import * as moment from "moment"
import { Goal } from "@curefit/gmf-common";
import TextInput from "../TextInput";
import * as _ from "lodash";
import { IMetricData } from "@curefit/metrics-common";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import ILifestyleGoal from "../../models/ILifestyleGoal";
import {default as CustomHeader, ICustomHeaderInfo} from "../utils/CustomHeader";
import GoalChartComponent from "../GoalChartComponent";
import CustomSelect from "../CustomSelect";
import IMetric from "../../models/metrics/IMetric";
import MetricLegendContainer from "../../containers/MetricLegendContainer";
import ModelFactory from "../../models/ModelFactory";
import DurationComponent from "../DurationComponent";
import {TypeAheadElement} from "../TypeAhead";
import AppUtils from "../../utils/AppUtils";
import {AppConstants} from "../../utils/AppConstants";
import * as $ from "jquery";
import AdvancedDurationComponent from "../AdvancedDurationComponent";
import { IFitnessSchedule } from "../../models/IFitnessPrescription";

/**
 * Created by aditya on 16/07/18.
 */

let GoalItemEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "metric", display: "METRIC", mandatory: true},
    {label: "current", display: "INITIAL", mandatory: true},
    /*{label: "ideal", display: "TARGET", mandatory: true},*/
    {label: "duration", display: "FREQUENCY", mandatory: true}
];

let GoalItemTargetEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "aim", display: "AIM", mandatory: true},
    {label: "ideal", display: "TARGET", mandatory: true},
    {label: "min", display: "RANGE MIN"},
    {label: "max", display: "RANGE MAX"},
];

export interface HealthTargetItemEditorProps {
    isGoalFilled?: boolean;
    goalsType?: string;
    consultationType?: string,
    item: ILifestyleGoal;
    onDataChange: (update: any) => any,
    staticMetrics: IMetric[],
    startDate: string,
    staticGoals: {[key: string]: Goal},
    addUserMetric: (metricId: string, metricValue: number) => Promise<any>,
    patientMetrics: {[metricId: number]: IMetricData[]},
    getUserUpdatedMetrics: (metricId: string) => void,
    userId: number;
    secondaryUserId: number;
    isSelf: boolean;
    allSelectedMetricIds: number[];
    isGoalNameDisabled: boolean;
    patientAllSavedMetrics: ILifestyleGoal[];
    setAssessmentMetric?: (metricId: string) => void
}

export interface HealthTargetItemEditorState {
    addMetricField?: boolean;
    addMetricValue?: string;
    isUserMetricSaved?: boolean;
    validate: boolean;
}

class HealthTargetItemEditor extends React.Component<HealthTargetItemEditorProps, HealthTargetItemEditorState> {
    private healthTargetItemDOM: any;

    constructor(props: HealthTargetItemEditorProps) {
        super(props);
        this.state = {
            addMetricField: false,
            addMetricValue: "",
            isUserMetricSaved: false,
            validate: false
        }
    }

    componentDidMount() {
        let myInstance = this;
        $(this.healthTargetItemDOM).find("input").on("blur", function() {
            setTimeout(function() {
                if ( $(myInstance.healthTargetItemDOM).find("input:focus").length === 0 ) {
                    myInstance.setState({validate: true})
                }
            }, 100)
        })
    }

    onIdealValueChange = (evt: any) => {
        if (this.props.goalsType === "PRIMARY") {
            if (!isNaN(parseInt(evt.target.value)) || evt.target.value === "") {
                let value = !isNaN(Number(evt.target.value)) ? evt.target.value : "";
                let idealValue = { ...this.props.item.idealValue, value };
                let currentItem = { ...this.props.item, idealValue };
                this.props.onDataChange(currentItem);
            }
        } else {
            let value = evt.target.value;
            let idealValue = { ...this.props.item.idealValue, value };
            let currentItem = { ...this.props.item, idealValue };
            this.props.onDataChange(currentItem);
        }
    }

    getMetricNameFromId = (id: string) => {
        let metricName = "";
        _.map(Object.values(this.props.staticMetrics), (item: IMetric) => {
            if (item.id === id) {
                metricName = item.name;
                return false;
            }
        })
        return metricName;
    }

    updateMetric = (value: string) => {
        if (AppUtils.isDefined(value)) {
            const metricItem = ModelFactory.createNewLifestyleGoal();
            let currentItem = { ...metricItem, metricId: value, metricName: this.getMetricNameFromId(value) };
            this.props.onDataChange(currentItem)
        }
        this._closeRecordMetricField()
    }

    onMinValueChange = (evt: any) => {
        let value = evt.target.value;
        if (this.props.goalsType === "PRIMARY") {
            if (!isNaN(Number(value)) || value === "") {
                value = !isNaN(Number(evt.target.value)) ? value === "" ? null : evt.target.value : "";
                let idealValue = { ...this.props.item.idealValue, range: { ...this.props.item.idealValue.range, min: value } };
                let currentItem = { ...this.props.item, idealValue };
                this.props.onDataChange(currentItem);
            }
        } else {
            let idealValue = { ...this.props.item.idealValue, range: { ...this.props.item.idealValue.range, min: value } };
            let currentItem = { ...this.props.item, idealValue };
            this.props.onDataChange(currentItem);
        }
    }

    onMaxValueChange = (evt: any) => {
        let value = evt.target.value;
        if (this.props.goalsType === "PRIMARY") {
            if (!isNaN(Number(value)) || value === "") {
                value = !isNaN(Number(evt.target.value)) ? evt.target.value : "";
                let idealValue = { ...this.props.item.idealValue, range: { ...this.props.item.idealValue.range, max: value } };
                let currentItem = { ...this.props.item, idealValue };
                this.props.onDataChange(currentItem);
            }
        } else {
            let idealValue = { ...this.props.item.idealValue, range: { ...this.props.item.idealValue.range, max: value } };
            let currentItem = { ...this.props.item, idealValue };
            this.props.onDataChange(currentItem);
        }
    }

    onCurrentValueChange = (evt: any) => {
        let value = evt.target.value;
        if (!isNaN(Number(value)) || value === "") {
            value = !isNaN(Number(evt.target.value)) ? evt.target.value : "";
            let currentValue = { ...this.props.item.currentValue, value };
            let currentItem = { ...this.props.item, currentValue };
            this.setState({
                isUserMetricSaved: false
            }, () => {
                this.props.onDataChange(currentItem);
            })
        }
    }

    onMetricValueChange = (evt: any, index: number) => {
        if (this.props.goalsType === "PRIMARY") {
            if (!isNaN(evt.target.value) && !isNaN(Number(evt.target.value)) || evt.target.value === "") {
                let value = !isNaN(Number(evt.target.value)) ? evt.target.value : "";
                let {startDate} = this.props;
                let requiredDate = moment(startDate).add(index, "M").valueOf();
                let targets = !_.isEmpty(this.props.item.targets) ? [ ...this.props.item.targets ] : [];
                if (targets.map(item => moment(item.targetEpoch).valueOf()).indexOf(requiredDate) !== -1) {
                    let requiredIndex = targets.map(item => moment(item.targetEpoch).valueOf()).indexOf(requiredDate);
                    if (evt.target.value === "") {
                        targets.splice(requiredIndex, 1);
                    } else {
                        targets[requiredIndex].value = value;
                    }
                    this.props.onDataChange({ ...this.props.item, targets: targets })
                } else {
                    let metricValue = { targetEpoch: requiredDate as any, value }
                    targets.push(metricValue);
                    this.props.onDataChange({ ...this.props.item, targets: targets })
                }
            }
        } else {
            let value = evt.target.value;
            let {startDate} = this.props;
            let requiredDate = moment(startDate).add(index, "M").format("YYYY-MM-DD");
            let targets = !_.isEmpty(this.props.item.targets) ? [ ...this.props.item.targets ] : [];
            if (targets.map(item => moment(item.targetEpoch).format("YYYY-MM-DD")).indexOf(requiredDate) !== -1) {
                let requiredIndex = targets.map(item => moment(item.targetEpoch).format("YYYY-MM-DD")).indexOf(requiredDate);
                targets[requiredIndex].value = value;
                this.props.onDataChange({ ...this.props.item, targets: targets })
            } else {
                let metricValue = { targetEpoch: requiredDate, value }
                targets.push(metricValue);
                this.props.onDataChange({ ...this.props.item, targets: targets })
            }
        }
    }

    getMetricValue = (index: number) => {
        let {startDate} = this.props;
        let requiredDate = moment(startDate).add(index, "M").valueOf();
        let targets = !_.isEmpty(this.props.item.targets) ? [ ...this.props.item.targets ] : [];
        let requiredIndex = targets.map(item => moment(item.targetEpoch).valueOf()).indexOf(requiredDate);
        if (requiredIndex !== -1) {
            return targets[requiredIndex].displayValue !== undefined ? targets[requiredIndex].displayValue : targets[requiredIndex].value;
        } else {
            return "";
        }
    }

    getMetricDate = (index: number) => {
        let {startDate} = this.props;
        let requiredDate = moment(startDate).add(index, "M").valueOf();
        let targets = !_.isEmpty(this.props.item.targets) ? [ ...this.props.item.targets ] : [];
        if (targets.map(item => moment(item.targetEpoch).valueOf()).indexOf(requiredDate) !== -1) {
            let requiredIndex = targets.map(item => moment(item.targetEpoch).valueOf()).indexOf(requiredDate);
            return targets[requiredIndex].targetEpoch;
        } else {
            return "";
        }
    }

    generateChartRows = () => {
        let rowArray: any = [];
        if (AppUtils.isDefined(this.props.patientMetrics) && AppUtils.isDefined(this.props.patientMetrics[this.props.item.metricId as any])) {
            this.props.patientMetrics[this.props.item.metricId as any].forEach((metric: IMetricData, index: number) => {
                let date = new Date(metric.metricDate);
                let fullDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
                let item = [];
                // console.log("__DATE__", date.getMonth() + 1, date.getDate(), date.getFullYear());
                item.push(date.getMonth() + 1);
                item.push(metric.value);
                let hoverItem = `<div style="padding: 5px; min-width: 60px"><div style="font-size: 14px; font-weight: bold">${metric.value}</div><div style="font-size: 8px">${fullDate}</div></div>`;
                item.push(hoverItem);
                rowArray.push(item as any);
            })
        }
        return rowArray;
    }

    generateGoalMerticItems = () => {
        const hasSelectedMetrics = !_.isEmpty(this.props.allSelectedMetricIds);
        const metricsToDisplay = hasSelectedMetrics ? _.map(this.props.staticMetrics).filter(item => this.props.allSelectedMetricIds.indexOf(item.id) < 0) : this.props.staticMetrics;
        let goalItems: IStaticDataValue[] = [];
        _.map(metricsToDisplay, (metric: IMetric) => {
            goalItems.push({ internalValue: metric.id, displayValue: metric.name });
        })
        return goalItems;
    }

    getMetricNameFromMetricId = (metricId: string) => {
        let metrics = Object.values(this.props.staticMetrics);
        let metricIds = metrics.map((item: any) => item.id);
        let index = metricIds.indexOf(metricId);
        if (index !== -1) return metrics[index].name;
        else return "";
    }

    getMetricFromMetricId = (metricId: string): IMetric => {
        let metrics = Object.values(this.props.staticMetrics);
        let metricIds = metrics.map((item: any) => item.id);
        let index = metricIds.indexOf(metricId);
        if (index !== -1) return metrics[index];
        else null;
    }

    generateFrequencyListItems = () => {
        let frequencyList: IStaticDataValue[] = [];
        _.map(AppConstants.FrequencyUnit, (type, key) => {
            let medicineFrequency = ModelFactory.createNewStaticItem();
            medicineFrequency.internalValue = key;
            medicineFrequency.displayValue = type;
            frequencyList.push(medicineFrequency);
        });
        return frequencyList;
    }

    _handleHealthtargetDurationChange = (elem: TypeAheadElement) => {
        let updatedItem = { ...this.props.item, trackingFreq: elem.others.value };
        this.props.onDataChange(updatedItem);
    };
    
    // _handleHealthtargetDurationChange = (elem: IFitnessSchedule) => {
    //     let updatedItem = { ...this.props.item, trackingFreq: elem };
    //     this.props.onDataChange(updatedItem);
    // };

    onAddMetricValueChange = (evt: any) => {
        let value = evt.target.value;
        if (!isNaN(Number(value))) {
            this.setState({
                addMetricValue: value
            })
        }
    }

    addMetric = () => {
        this.props.addUserMetric(this.props.item.metricId, Number(this.state.addMetricValue)).then(() => {
            this.props.getUserUpdatedMetrics(this.props.item.metricId);
            this.setState({addMetricField: false})
        });
    }

    recordInitialMetric = () => {
        this.props.addUserMetric(this.props.item.metricId, Number(this.props.item.currentValue.value)).then(() => {
            this.setState({isUserMetricSaved: true}, () => {
                this.props.getUserUpdatedMetrics(this.props.item.metricId);
            })
        });
    }

    _getMetricUnit = (): string => {
        if (!_.isEmpty(this.props.staticMetrics)) {
            const selectedMetricId = this.props.item.metricId;
            let metric = _.map(this.props.staticMetrics, (metric) => metric).find(item => item.id === selectedMetricId);
            if (AppUtils.isDefined(metric)) return metric.unit;
            else return null
        } else return null
    };

    _closeRecordMetricField = () => {
        this.setState({ addMetricField: false })
    };

    _showRecordMetricField = () => {
        this.setState({addMetricField: true})
    }

    generateMonthsHeader = (): ICustomHeaderInfo[] => {
        let monthsHeader: ICustomHeaderInfo[] = [];
        monthsHeader.push({
            label: "months-label",
            display: "MONTHS"
        })
        _.times(12, (index: number) => {
            monthsHeader.push({
                label: "month-header",
                display: `M${index + 1}`
            })
        });
        return monthsHeader;
    }

    generateMonthsSubHeader = (): ICustomHeaderInfo[] => {
        let monthsHeader: ICustomHeaderInfo[] = [];
        monthsHeader.push({
            label: "months-label",
            display: "starts on"
        })
        _.times(12, (index: number) => {
            let {startDate} = this.props;
            monthsHeader.push({
                label: "month-header",
                display: moment(startDate).add(index + 1, "M").format("D-MMM")
            })
        });
        return monthsHeader;
    }

    generateAimDropdownValues = (): IStaticDataValue[] => {
        let dropdownList: IStaticDataValue[] = []
        _.map(AppConstants.goalTargetAims, (value: string, key: string) => {
            dropdownList.push({
                internalValue: key,
                displayValue: value
            })
        })
        return dropdownList;
    }

    onTargetAimChange = (item: string) => {
        let updatedItem = { ...this.props.item, aim: item };
        this.props.onDataChange(updatedItem);
    }

    _getRecordedValue = (monthIndex: number): string | number => {
        let value = null;
        if (AppUtils.isDefined(this.props.patientMetrics) && !_.isEmpty(this.props.patientMetrics[this.props.item.metricId as any])) {
            const currentMetric: IMetricData[] = this.props.patientMetrics[this.props.item.metricId as any];
            const requiredEndDateEpoch = AppUtils.getRequiredGoalMilestoneDayEpoch(Number(this.props.startDate), monthIndex, "END");
            const requiredStartDateEpoch = AppUtils.getRequiredGoalMilestoneDayEpoch(Number(this.props.startDate), monthIndex - 1, "START");
            const requiredMetricEpochs = currentMetric.filter((metricItem: IMetricData) => metricItem.metricDate >= requiredStartDateEpoch && metricItem.metricDate <= requiredEndDateEpoch);
            const latestRecordedValueEpoch = !_.isEmpty(requiredMetricEpochs) ? Math.max.apply(null, requiredMetricEpochs.map(item => item.metricDate)) : null;
            if (AppUtils.isDefined(latestRecordedValueEpoch)) {
                value = requiredMetricEpochs.find(item => item.metricDate === latestRecordedValueEpoch).value;
            }
        }
        return value;
    };

    _setAssessmentMetricId = () => {
        this.props.setAssessmentMetric(this.props.item.metricId)
    };

    render() {
        let idealValue = AppUtils.isDefined(this.props.item.idealValue) && !_.isNull(this.props.item.idealValue.value) ? this.props.item.idealValue.value : "";
        let idealValueValidationStatus = this.state.validate && !ModelFactory.isValidGoalTarget(this.props.item.idealValue) ? "error" : "";
        let selectedMetric = this.props.item.metricId !== undefined && this.props.item.metricId !== null ? this.getMetricNameFromMetricId(this.props.item.metricId) : null;
        let metricValidationStatus = this.state.validate && _.isNull(selectedMetric) ? "error" : "";
        let minValue =  AppUtils.isDefined(this.props.item.idealValue) && AppUtils.isDefined(this.props.item.idealValue.range) ? this.props.item.idealValue.range.min : "";
        let maxValue =  AppUtils.isDefined(this.props.item.idealValue) && AppUtils.isDefined(this.props.item.idealValue.range) ? this.props.item.idealValue.range.max : "";
        let currentValue =  AppUtils.isDefined(this.props.item.currentValue) && !_.isNull(this.props.item.currentValue.value) ? this.props.item.currentValue.value : "";
        let currentValueValidationStatus = this.state.validate && currentValue === "" ? "error" : "";
        let isMetricFilled = !_.isNull(selectedMetric);
        let selectedMetricObj = this.props.item.metricId !== undefined && this.props.item.metricId !== null ? this.getMetricFromMetricId(this.props.item.metricId) : null;
        let addMetricValue = this.state.addMetricValue;
        let formattedStartDate = AppUtils.isDefined(this.props.startDate) ? moment(this.props.startDate).format("Do MMMM, YYYY") : null;
        // const trackingFreqFrequency = AppUtils.isDefined(this.props.item.trackingFreq) && AppUtils.isDefined(this.props.item.trackingFreq.frequency) ? this.props.item.trackingFreq.frequency : null;
        const trackingFreqCount = AppUtils.isDefined(this.props.item.trackingFreq) && AppUtils.isDefined(this.props.item.trackingFreq.count) ? this.props.item.trackingFreq.count : null;
        const trackingFreqUnit = AppUtils.isDefined(this.props.item.trackingFreq) && AppUtils.isDefined(this.props.item.trackingFreq.unit) ? this.props.item.trackingFreq.unit : null;
        let trackingFrequencyValidationStatus = this.state.validate && _.isNull(trackingFreqUnit) ? "error" : "";
        const assessmentLink = AppUtils.getAssessmentLink(selectedMetricObj, this.props.userId, this.props.isSelf, this.props.secondaryUserId);
        const metricUnit = this._getMetricUnit();
        let targetAim = !_.isEmpty(this.props.item.aim) ? AppConstants.goalTargetAims[this.props.item.aim as any] : null;
        let targetAimValidationStatus = _.isNull(targetAim) ? "error" : "";
        const patientAllSavedMetricsIds = this.props.patientAllSavedMetrics.map(metric => metric.metricId);
        // console.log("CHECK", this.props.isGoalNameDisabled, AppUtils.isDefined(this.props.item.metricId), patientAllSavedMetricsIds, this.props.item.metricId, patientAllSavedMetricsIds.indexOf(this.props.item.metricId) > -1)
        return (
            <div className="health-target-item-editor" ref={(healthTargetItemDOM) => this.healthTargetItemDOM = healthTargetItemDOM}>
                <div className={"metric-container"}>
                    {
                        this.props.goalsType === "PRIMARY" &&
                        <div className={"goal-chart-container"}>
                            <GoalChartComponent currentValue={""} averageValue={""}
                                                rows={this.generateChartRows()} chartName={`metric-chart-${new Date().getTime()}`}
                                                rootClass={"patient-health-targets-chart"} subClass={"metric"}
                                                title={""} key={`chart-component`}/>
                        </div>
                    }
                    {
                        this.props.goalsType === "PRIMARY" && isMetricFilled &&
                        <div className={"health-target-item-editor-add-metric"}>
                            {
                                !this.state.addMetricField && _.isNull(assessmentLink) &&
                                <span onClick={this._showRecordMetricField}>Record a metric</span>
                            }
                            {
                                !_.isNull(assessmentLink) &&
                                <a href={assessmentLink} target="_blank" onClick={this._setAssessmentMetricId}>Take Assessment</a>
                            }
                            {
                                this.state.addMetricField && _.isNull(assessmentLink) &&
                                <div className={"add-metric-container"}>
                                    <TextInput name={"addMetric"} value={addMetricValue} onChange={this.onAddMetricValueChange}/>
                                    <input type="button" value="Record Metric" className={"card-primary-action"} onClick={this.addMetric} />
                                    <span onClick={this._closeRecordMetricField}>Cancel</span>
                                </div>
                            }
                        </div>
                    }
                </div>
                {
                    this.props.goalsType === "PRIMARY" &&
                    <CustomHeader headerInfos={GoalItemEditorHeaderInfos} rootCls={"patient-goal"}/>
                }
                {
                    this.props.goalsType === "PRIMARY" &&
                    <div className={`health-target-item-editor-metric ${metricValidationStatus}`}>
                        <CustomSelect disabled={!this.props.isGoalFilled || (this.props.isGoalNameDisabled && AppUtils.isDefined(this.props.item.metricId) && patientAllSavedMetricsIds.indexOf(this.props.item.metricId) > -1)} dropdownValues={this.generateGoalMerticItems()} selectedValue={selectedMetric} defaultValue={"Select"} updateDropdownValue={this.updateMetric}/>
                        {
                            AppUtils.isDefined(metricUnit) && metricUnit !== "" &&
                            <span className={"metric-unit"}>{`(${metricUnit})`}</span>
                        }
                    </div>
                }
                {/*{
                    this.props.goalsType === "secondary" &&
                    <div className={"health-target-item-editor-metric"}>
                        <TextInput name={"health-target-metric-name"} onChange={this.onGoalMetricNameChange} value={this.props.item.goalMetricId}/>
                    </div>
                }*/}
                {
                    this.props.goalsType === "PRIMARY" &&
                    <div className={`health-target-item-editor-current ${currentValueValidationStatus}`}>
                        <TextInput disabled={!isMetricFilled} name={"health-target-current"} value={currentValue} onChange={this.onCurrentValueChange} />
                        {
                            !_.isEmpty(currentValue) && !this.state.isUserMetricSaved &&
                                <a className={"record-button"} onClick={this.recordInitialMetric}>Record</a>
                        }
                        {
                            this.state.isUserMetricSaved &&
                                <span className={"glyphicon glyphicon-ok"}></span>
                        }
                    </div>
                }
                {
                    this.props.goalsType === "PRIMARY" &&
                    <div className={`health-target-item-editor-duration ${trackingFrequencyValidationStatus}`}>
                        <DurationComponent unit={trackingFreqUnit} count={trackingFreqCount} rootClass={"health-target-duration"} 
                            dropdownItems={this.generateFrequencyListItems()} 
                            isFrequency={true} 
                            onDurationChange={this._handleHealthtargetDurationChange} 
                            disabled={!this.props.isGoalFilled}/>
                        {/* <AdvancedDurationComponent frequency={trackingFreqFrequency} unit={trackingFreqUnit} count={trackingFreqCount}
                            rootClass={"health-target-duration"}
                            onDurationChange={this._handleHealthtargetDurationChange} 
                            disabled={!this.props.isGoalFilled}/> */}
                    </div>
                }
                <br/><br/>
                {
                    this.props.goalsType === "PRIMARY" &&
                    <CustomHeader headerInfos={GoalItemTargetEditorHeaderInfos} rootCls={"patient-goal"}/>
                }
                {
                    this.props.goalsType === "PRIMARY" &&
                    <div className={`health-target-item-editor-aim ${targetAimValidationStatus}`}>
                        <CustomSelect disabled={!isMetricFilled} dropdownValues={this.generateAimDropdownValues()} selectedValue={targetAim} defaultValue={"Select"} updateDropdownValue={this.onTargetAimChange} />
                    </div>
                }
                {
                    this.props.goalsType === "PRIMARY" &&
                    <div className={`health-target-item-editor-ideal ${idealValueValidationStatus}`}>
                        <TextInput disabled={!isMetricFilled} name={"health-target-ideal"} value={idealValue} onChange={this.onIdealValueChange} />
                    </div>
                }
                {
                    this.props.goalsType === "PRIMARY" &&
                    <div className={`health-target-item-editor-min ${idealValueValidationStatus}`}>
                        <TextInput disabled={!isMetricFilled} name={"health-target-min"} value={minValue} onChange={this.onMinValueChange} />
                    </div>
                }
                {
                    this.props.goalsType === "PRIMARY" &&
                    <div className={`health-target-item-editor-max ${idealValueValidationStatus}`}>
                        <TextInput disabled={!isMetricFilled} name={"health-target-max"} value={maxValue} onChange={this.onMaxValueChange} />
                    </div>
                }
                {
                    !_.isEmpty(selectedMetricObj) && !_.isEmpty(selectedMetricObj.rangeBuckets) &&
                        <MetricLegendContainer rangeBuckets={selectedMetricObj.rangeBuckets} />
                }
                <CustomHeader headerInfos={this.generateMonthsHeader()} rootCls={"patient-goal-months-header"}/>
                <CustomHeader headerInfos={this.generateMonthsSubHeader()} rootCls={"patient-goal-months-sub-header"}/>
                <div className={"month-target-input-container label-container"}>
                    <div>MILESTONES</div>
                    <div>RECORDED</div>
                </div>
                {
                    _.times(12, (index: number) => {
                        return <div className={"month-target-input-container"} key={`health-target-month-input-container-${index}`}>
                            <div>
                                <TextInput disabled={!isMetricFilled} name={`doctor-target-input-${index + 1}`} onChange={(evt) => this.onMetricValueChange(evt, index + 1)} value={this.getMetricValue(index + 1)}/>
                            </div>
                            <div>
                                <TextInput name={`patient-target-input-${index + 1}`} disabled={true} value={this._getRecordedValue(index + 1)}/>
                            </div>
                        </div>
                    })
                }
                {
                    this.props.goalsType === "PRIMARY" && !_.isNull(formattedStartDate) &&
                    <div className={"milstones-start-date-info-container"}>{`The milestones start from ${formattedStartDate}`}</div>
                }
            </div>
        )
    }
}

export default HealthTargetItemEditor;